/* 
PUBLIC PAGE 
*/
import React from "react";
import ConfirmSignup from "../Components/ConfirmSignUp/ConfirmSignUp";
import Layout from "../Components/Layout/Layout";

function ConfirmSignUpPage() {
  return (
    <Layout>
      <ConfirmSignup />
    </Layout>
  );
}

export default ConfirmSignUpPage;
